<template>
  <div class="w-100 text-center mt-3">
    <div class="form-row justify-center">
      <span class="ml-4 mr-auto span-text">Summary & Correlations</span>
      <button class="ml-auto btn next-button" @click="downloadFile('summary.xlsx')">
        Download summary
      </button>
    </div>
    <div class="table-row text-center ml-auto mr-auto mb-4">
      <VClientTable
        class="hide-filters"
        :data="data['data']"
        :columns="data['headers']"
        :options="[]"
      >
        <template v-for="colSlot in data['headers']" v-slot:[colSlot]="{ row }">
          {{ row[colSlot] ? row[colSlot] : '-' }}
        </template>
      </VClientTable>
    </div>
  </div>
</template>

<script>
import VClientTable from '@/components/shared/VClientTable'

export default {
  name: 'RDFSummary',
  components: { VClientTable },
  props: {
    data: Object,
    downloadFile: Function
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.hide-filters {
  .VueTables__search-field {
    display: none !important;
  }
  .vgt-global-search {
    display: none !important;
  }
  .after-filter-wrapper {
    width: 100%;
    justify-content: flex-end;
    .info-text {
      margin-right: 15px;
    }
  }
}

.next-button {
  font-family: 'Open Sans', sans-serif;
  font-weight: 900;
  line-height: 30px;
  letter-spacing: 0;
  background-color: $blueberry;
  color: white;
  text-transform: uppercase;
  border-radius: 4px;
  margin-right: 30px;
  margin-bottom: 15px;
  width: 160px;
  height: 38px;
  padding: 1px 2px;
  @media screen and (min-width: $break-lg) {
    width: 180px;
    height: 40px;
    padding: 2px 3px;
    font-size: 12px;
  }
  @media screen and (min-width: $break-xl) {
    width: 200px;
    height: 42px;
    padding: 3px;
    font-size: 13px;
  }
  @media screen and (min-width: $break-xxl) {
    width: 240px;
    height: 44px;
    padding: 3px 4px;
    font-size: 16px;
  }
  transition: background-color 0.2s linear;
  &:hover {
    background-color: #9256D9;
  }
}

.span-text {
  font-size: 1.6rem;
}

</style>
